import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  TwitterAuthProvider,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword
} from "firebase/auth";
import app from "../firebaseConfig";
import { useState } from "react";

export default function LoginButtons({ onLogin }) {
  const auth = getAuth(app);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      onLogin(result.user);
    } catch (error) {
      console.error("Googleログイン失敗:", error);
    }
  };

  const handleTwitterLogin = async () => {
    const provider = new TwitterAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      onLogin(result.user);
    } catch (error) {
      console.error("Xログイン失敗:", error);
    }
  };

  const handleEmailLogin = async () => {
    try {
      const result = await signInWithEmailAndPassword(auth, email, password);
      onLogin(result.user);
    } catch (error) {
      console.error("メールログイン失敗:", error);
    }
  };

  const handleEmailSignup = async () => {
    try {
      const result = await createUserWithEmailAndPassword(auth, email, password);
      onLogin(result.user);
    } catch (error) {
      console.error("メール登録失敗:", error);
    }
  };

  return (
    <div style={{ marginTop: "30px", padding: "20px", background: "#f5f5f5", borderRadius: "8px" }}>
      <h3 style={{ marginBottom: "16px" }}>灯主として棚に灯りを置くにはログインが必要です</h3>

      <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginBottom: "20px" }}>
        <button onClick={handleGoogleLogin} style={buttonStyle}>Googleでログイン</button>
        <button onClick={handleTwitterLogin} style={buttonStyle}>Xでログイン</button>
      </div>

      <div style={{ marginTop: "10px" }}>
        <h4 style={{ marginBottom: "8px" }}>メールでログイン / 登録</h4>
        <input
          type="email"
          placeholder="メールアドレス"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={inputStyle}
        />
        <input
          type="password"
          placeholder="パスワード"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={inputStyle}
        />
        <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
          <button onClick={handleEmailLogin} style={buttonStyle}>ログイン</button>
          <button onClick={handleEmailSignup} style={buttonStyle}>登録</button>
        </div>
      </div>
    </div>
  );
}

const buttonStyle = {
  padding: "10px 16px",
  background: "#fff",
  border: "1px solid #ccc",
  borderRadius: "6px",
  cursor: "pointer",
  fontSize: "14px"
};

const inputStyle = {
  padding: "8px",
  marginBottom: "8px",
  width: "100%",
  borderRadius: "4px",
  border: "1px solid #ccc"
};
